// extracted by mini-css-extract-plugin
module.exports =  {"cannyPostButton":"Wv3H8vbP","sourceLink":"R2G3fLCm","queueSourceLogo":"NK4VJqAI","queueSourceLabel":"XcQFrVLk"};